import React from "react";
import PropTypes from "prop-types";
import { withStore, withScreenCheck } from "../hoc";
import "../css/TextPage.css";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import Image from "../components/ImageElement";
import Body from "../components/Body";
import Footer from "../components/Footer";
import { Card, CardText, CardTextChronique } from "../components/Cards";

/**
 * TextPage
 */
class TextPage extends React.Component {
  static displayName = "TextPage";
  static propTypes = {
    stores: PropTypes.object.isRequired,
    currentPage: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
  };

  static defaultProps = {};

  /**
   * @override
   */
  render() {
    const { currentPage } = this.props;
    return (
      <div className="TextPage">
        <Navbar {...this.props} />
        <Header
          {...this.props}
          images={[
            this.props.screen === "desktop"
              ? this.props.currentPage.heroImage()
              : this.props.currentPage.heroMobileImage(),
          ]}
        >
          {currentPage.heroCaption()}
        </Header>
        <Body {...this.props}>
          {/* FIXME : USE another card component, to display as many images as possibles. see section.images(). */}
          <div
            className={`TextPage__container TextPage__container--${currentPage.SectionType[0]}`}
          >
            {currentPage.SectionType === "1 colonne" ? (
              currentPage
                .sections()
                .map((section) => (
                  <CardText card={section} key={section.ID} {...this.props} />
                ))
            ) : (
              <CardTextChronique
                sections={currentPage.sections()}
                {...this.props}
              />
            )}
          </div>

          {currentPage.CertificationTitle && (
            <Card
              title={currentPage.CertificationTitle}
              className="full Card--Certifications"
            >
              <div className={`Certifications__imgs`}>
                {currentPage.certificationImages().map((image) => {
                  return (
                    <div className={`Certifications__img`} key={image.ID}>
                      <Image
                        className={image.isLandscape ? "landscape" : "portrait"}
                        src={image[`${this.props.screen}_src`]}
                        alt={image.alt}
                      />
                    </div>
                  );
                })}
              </div>
            </Card>
          )}
        </Body>
        <Footer {...this.props} />
      </div>
    );
  }
}
export default withStore(withScreenCheck(TextPage));



// WEBPACK FOOTER //
// ./src/pages/TextPage.js